import { Typography, Box, useTheme } from "@mui/material";
import React from "react";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography
        variant="h4"
 sx={{ mb: "5px", color: theme.palette.secondary[100], fontWeight: "bold" }}>
        {title}
      </Typography>
      <Typography variant="h7"
 sx={{ color: theme.palette.secondary[300] }}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
